import { render, staticRenderFns } from "./FiltersTree.vue?vue&type=template&id=707020d4&lang=pug&"
import script from "./FiltersTree.vue?vue&type=script&lang=js&"
export * from "./FiltersTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports